import { Color } from 'csstype'
import React from 'react'
import { CidadaoListagemHipertensaoQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection'
import { AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSection } from './AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSection'

interface AcompanhamentoCondicaoSaudeHipertensaoAccordionPanelProps {
  row: CidadaoListagemHipertensaoQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeHipertensaoAccordionPanel({
  row,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeHipertensaoAccordionPanelProps>) {
  return (
    <>
      <AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSection
        dataUltimaConsulta={row?.cidadao.cidadaoConsolidado.hipertensao.dataUltimaConsulta}
        qtdPressaoArterial={row?.cidadao.cidadaoConsolidado.hipertensao.qtdPressaoArterial}
        qtdConsulta={row?.cidadao.cidadaoConsolidado.hipertensao.qtdConsulta}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection
        dataUltimasVisitasDomiciliares={
          row?.cidadao?.cidadaoConsolidado?.hipertensao?.visitaDomiciliar?.dataUltimasVisitasDomiciliares
        }
        qtdVisitasDomiciliares={row?.cidadao?.cidadaoConsolidado?.hipertensao?.visitaDomiciliar?.qtdVisitasDomiciliares}
        iconColor={iconColor}
      />
    </>
  )
}
